<template>
<b-row>
  <b-col
      md="6"
      sm="6"
  >
    <b-row>
      <b-col
          md="5"
          sm="5"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="defaultPrice.perPage"
              size="sm"
              :options="defaultPrice.pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>

      <b-col
          md="5"
          sm="5"
          class="my-1"
      >
      <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
              id="filterInput"
              v-model="defaultPrice.filter"
              type="search"
              placeholder="Name, Telefon etc"
          />
          <b-input-group-append>
            <b-button
                :disabled="!defaultPrice.filter"
                @click="defaultPrice.filter = ''"
            >
              Leeren
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      </b-col>

      <b-col
          md="2"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-button
                size="sm"
                variant="info"
                class="btn-block"
                @click="Add"
            >
              Neuer Preis
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>
    </b-row>
    <b-col cols="12">
      <b-table
          striped
          hover
          responsive
          :per-page="defaultPrice.perPage"
          :items="defaultPrice.items"
          :fields="defaultPrice.fields"
          @row-clicked="Click"
      >
        <template #cell(FromDistance)="data">
          <div v-if=""></div>
          {{ data.item.FromDistance }} ({{ data.item.FromDistance/1000 }}km)
        </template>
        <template #cell(EnterAmount)="data">
          {{ FormatEuro(data.item.EnterAmount) }}
        </template>
        <template #cell(EnterAmount2)="data">
          {{ FormatEuro(data.item.EnterAmount2) }}
        </template>
        <template #cell(Amount)="data">
          {{ FormatEuro((data.item.Amount)) }}
        </template>
        <template #cell(Active)="data">
          <b-badge
              pill
              :variant="(GetDateState(data.item.ValidFrom) ? 'light-success' : 'light-primary')"
          >
            {{ GetDateState(data.item.ValidFrom) }}
          </b-badge>
        </template>
      </b-table>
    </b-col>

    <b-col
        cols="12"
    >
      <b-pagination
          v-model="defaultPrice.currentPage"
          :total-rows="defaultPrice.totalRows"
          :per-page="defaultPrice.perPage"
          align="center"
          size="sm"
          class="my-0"
      />
    </b-col>
  </b-col>
  <b-col
      md="6"
      sm="6"
  >
    <b-row>
      <b-col
          md="5"
          sm="5"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="taxi.perPage"
              size="sm"
              :options="taxi.pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>

      <b-col
          sm="5"
          md="5"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="taxi.filter"
                type="search"
                placeholder="Name, Telefon etc"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!taxi.filter"
                  @click="taxi.filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col
          md="2"
          am="2"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-button
                size="sm"
                variant="info"
                class="btn-block"
                @click="AddTaxi"
            >
              Neuer Taxi Preis
            </b-button>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-col cols="12">
      <b-table
          striped
          hover
          responsive
          :per-page="taxi.perPage"
          :items="taxi.items"
          :fields="taxi.fields"
          @row-clicked="ClickTaxi"
      >
        <template #cell(FromDistance)="data">
          <div v-if=""></div>
          {{ data.item.FromDistance }} ({{ data.item.FromDistance/1000 }}km)
        </template>
        <template #cell(EnterAmount)="data">
          {{ FormatEuro(data.item.EnterAmount) }}
        </template>
        <template #cell(EnterAmount2)="data">
          {{ FormatEuro(data.item.EnterAmount2) }}
        </template>
        <template #cell(Amount)="data">
          {{ FormatEuro((data.item.Amount)) }}
        </template>
        <template #cell(Active)="data">
          <b-badge
              pill
              :variant="(GetDateState(data.item.ValidFrom) ? 'light-success' : 'light-primary')"
          >
            {{ GetDateState(data.item.ValidFrom) }}
          </b-badge>
        </template>
      </b-table>
    </b-col>

    <b-col
        cols="12"
    >
      <b-pagination
          v-model="taxi.currentPage"
          :total-rows="taxi.totalRows"
          :per-page="taxi.perPage"
          align="center"
          size="sm"
          class="my-0"
      />
    </b-col>
  </b-col>
</b-row>
</template>


<script>

import BCardCode from '@core/components/b-card-code'
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      defaultPrice: {
        lastClickedRow: -1,
        perPage: 25,
        pageOptions: [10, 25, 50, 100],
        totalRows: 1,
        currentPage: 1,
        filter: null,
        filterTimeout: null,
        fields: [
          {
            key: 'Name',
            label: 'Name',
          },
          {
            key: 'FromDistance',
            label: 'Ab Entfernung',
          },
          {
            key: 'EnterAmount',
            label: 'Preis Einstieg 1-3',
          },
          {
            key: 'EnterAmount2',
            label: 'Preis Einstieg 4-8',
          },
          {
            key: 'Amount',
            label: 'Preis pro km',
          },
          {
            key: 'Active',
            label: 'Aktiv',
          },
        ],
        items: [],
      },
      taxi: {
        lastClickedRow: -1,
        perPage: 25,
        pageOptions: [10, 25, 50, 100],
        totalRows: 1,
        currentPage: 1,
        filter: null,
        filterTimeout: null,
        fields: [
          {
            key: 'Name',
            label: 'Name',
          },
          {
            key: 'FromDistance',
            label: 'Ab Entfernung',
          },
          {
            key: 'EnterAmount',
            label: 'Preis Einstieg 1-3',
          },
          {
            key: 'EnterAmount2',
            label: 'Preis Einstieg 4-8',
          },
          {
            key: 'Amount',
            label: 'Preis pro km',
          },
          {
            key: 'Active',
            label: 'Aktiv',
          },
        ],
        items: [],
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Preise'
    })
    this.LoadList()
    this.LoadTaxiList()
    this.$watch(
        () => this.defaultPrice.currentPage,
        val => {
          this.LoadList()
          this.LoadTaxiList()
        },
    )
    this.$watch(
        () => this.taxi.currentPage,
        val => {
          this.LoadTaxiList()
        },
    )

    this.$watch(
        () => this.defaultPrice.perPage,
        val => {
          const v = this
          if (this.defaultPrice.filterTimeout) clearTimeout(this.defaultPrice.filterTimeout)
          this.defaultPrice.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.taxi.perPage,
        val => {
          const v = this
          if (this.taxi.filterTimeout) clearTimeout(this.taxi.filterTimeout)
          this.taxi.filterTimeout = setTimeout(() => {
            v.LoadTaxiList()
          }, 550)
        },
    )
    this.$watch(
        () => this.defaultPrice.filter,
        val => {
          const v = this
          if (this.defaultPrice.filterTimeout) clearTimeout(this.defaultPrice.filterTimeout)
          this.defaultPrice.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.taxi.filter,
        val => {
          const v = this
          if (this.taxi.filterTimeout) clearTimeout(this.taxi.filterTimeout)
          this.taxi.filterTimeout = setTimeout(() => {
            v.LoadTaxiList()
          }, 550)
        },
    )
    // Set the initial number of items
    this.defaultPrice.totalRows = this.defaultPrice.items.length
    this.taxi.totalRows = this.items.taxi.length
  },
  methods: {
    GetDateState(ValidFrom) {
      if(new Date() > new Date(ValidFrom))
        return true;
      return false;
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro);
    },
    Add() {
      this.$router.push({
        name: 'Price',
        params: { identId: 0, type: 0 }
      })
    },
    AddTaxi() {
      this.$router.push({
        name: 'Price',
        params: { identId: 0, type: 1 }
      })
    },
    Click(record, index) {
      this.$router.push({
        name: 'Price',
        params: { identId: record.IdentId, type : 0 }
      })
    },
    ClickTaxi(record, index) {
      this.$router.push({
        name: 'Price',
        params: { identId: record.IdentId, type : 1 }
      })
    },
    LoadList() {

      this.defaultPrice.items = []
      const c1 = (this.defaultPrice.currentPage - 1) * this.defaultPrice.perPage
      let url = `/price/list?from=${c1}&count=${this.defaultPrice.perPage}`
      if (this.defaultPrice.filter && this.defaultPrice.filter !== '') {
        url = `/price/list/filter?filter=${this.defaultPrice.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              this.defaultPrice.items.push(i.Value)
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
    LoadTaxiList() {

      this.taxi.items = []
      const c1 = (this.taxi.currentPage - 1) * this.taxi.perPage
      let url = `/taxi/price/list?from=${c1}&count=${this.taxi.perPage}`
      if (this.taxi.filter && this.taxi.filter !== '') {
        url = `/taxi/price/list/filter?filter=${this.taxi.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.taxi.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              this.taxi.items.push(i.Value)
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
